var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-outages-results",
      class: { "c-outages-results--list-view": _vm.outagePageView === "list" },
    },
    [
      _vm.filterOption !== "lv"
        ? [
            _vm._l(_vm.getAllFilteredOutages, function (outage) {
              return _c(
                outage.type == "planned"
                  ? "planned-outage-result"
                  : "unplanned-outage-result",
                {
                  key: outage.type + outage.id,
                  tag: "component",
                  attrs: { outage: outage },
                }
              )
            }),
            _vm._v(" "),
            _vm.getAllFilteredOutages.length === 0
              ? _c("div", { staticClass: "c-outages-results__no-outages" }, [
                  _c(
                    "div",
                    { staticClass: "c-outages-results__no-outages-inner" },
                    [
                      _c(
                        "h3",
                        { staticClass: "c-outages-results__no-outages-title" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.noOutagesText()) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "c-outages-results__no-outages-text" },
                        [_vm._v("\n          Are you without power?\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.cmsContent.noOutagesFoundLink
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "c-outages-results__no-outages-button readmore readmore__linkBox readmore__linkBox--orange",
                              attrs: {
                                href: _vm.cmsContent.noOutagesFoundLink,
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.cmsContent.noOutagesFoundText)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span"),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getAllFilteredOutages.length === 0 &&
            _vm.cmsContent.noOutagesFeaturePanel
              ? _c(
                  _vm.cmsContent.noOutagesFeaturePanel.Link ? "a" : "span",
                  {
                    tag: "component",
                    attrs: {
                      href: _vm.cmsContent.noOutagesFeaturePanel.Link || "",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "c-outages-results__feature-panel-image",
                      attrs: {
                        src: _vm.cmsContent.noOutagesFeaturePanel.Image,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.filterOption === "lv"
        ? [
            _vm._l(_vm.getFilteredLVOutagesGeoJson, function (lvOutage) {
              return _c("lv-outage-result", {
                key: lvOutage.properties.csvSuburbID,
                attrs: { "lv-outage": lvOutage },
              })
            }),
            _vm._v(" "),
            _vm.getFilteredLVOutagesGeoJson.length === 0
              ? _c("div", { staticClass: "c-outages-results__no-outages" }, [
                  _c(
                    "div",
                    { staticClass: "c-outages-results__no-outages-inner" },
                    [
                      _c(
                        "h3",
                        { staticClass: "c-outages-results__no-outages-title" },
                        [
                          _vm._v(
                            "\n          There are currently no individual outages by suburb\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "c-outages-results__no-outages-text" },
                        [_vm._v("\n          Are you without power?\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.cmsContent.noOutagesFoundLink
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "c-outages-results__no-outages-button readmore readmore__linkBox readmore__linkBox--orange",
                              attrs: {
                                href: _vm.cmsContent.noOutagesFoundLink,
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.cmsContent.noOutagesFoundText)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span"),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }